import { render } from "./fbx-button.vue?vue&type=template&id=632c080f&scoped=true"
import script from "./fbx-button.vue?vue&type=script&lang=js"
export * from "./fbx-button.vue?vue&type=script&lang=js"

import "./fbx-button.vue?vue&type=style&index=0&id=632c080f&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632c080f"]])

export default __exports__